import { View, Text } from "react-native";
import { Modal } from "../../../components";
import { useIntercomClient } from "../../../hooks/useIntercom";

export default function AgeRestrictionModal({
  visible,
  setVisible,
}: {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}) {
  const intercom = useIntercomClient();
  const handleContactMembershipServices = () => {
    intercom.presentMessageComposer();
  };

  return (
    <Modal
      {...{
        visible,
        title: "Minimum age requirement not met.",
        onDismiss: () => setVisible(false),
      }}
    >
      <View className="m-6" testID="age-restriction-modal">
        <Text className="text-regular-normal font-500 pb-2">
          To participate in the PAT event, you must be at least 18 years old on the day of the event. If you have questions or
          need further assistance, please{" "}
          <Text className="underline text-primary font-500" onPress={handleContactMembershipServices}>
            contact member services
          </Text>
          .
        </Text>
      </View>
    </Modal>
  );
}
